import { motion, useInView } from "framer-motion";
import { managementCertifications } from "../utilities/managementCertificatesData";
import { useRef } from "react";

const ManagementCertification = ({ title, li }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.5, once: true });

  const animation = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        ease: "linear",
        delay: 0.225 * index,
      },
    }),
  };

  return (
    <div className="space-y-7">
      {title && (
        <h1 className="text-center text-3xl font-semibold text-visBlue">
          {title}
        </h1>
      )}
      <ol className="text-lg font-normal">
        {li?.map((item, idx) => {
          return <li key={idx}>{item}</li>;
        })}
      </ol>
      <div ref={ref} className="flex flex-wrap justify-center gap-2 md:gap-8">
        {managementCertifications.map((certificate, index) => {
          return (
            <motion.img
              key={index + "ABC"}
              variants={animation}
              initial={"hidden"}
              animate={isInView ? "visible" : "hidden"}
              custom={index}
              className="w-48 h-48"
              src={certificate}
              alt=""
            />
          );
        })}
      </div>
    </div>
  );
};

export default ManagementCertification;
